import { type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '../lib/classnames';

interface PanelProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  tone?: 'surface' | 'surface-2';
  hover?: boolean;
}

/**
 * A neutral container with paper-card shadow. Used for panels and content blocks
 * that aren't the actual challenge cards themselves (those use ChallengeCard).
 */
export function Panel({ children, className, tone = 'surface', hover, ...rest }: PanelProps) {
  return (
    <div
      className={cn(
        'rounded-card border border-ink/8 shadow-card',
        tone === 'surface' ? 'bg-surface' : 'bg-surface-2',
        hover && 'transition hover:shadow-card-hover hover:-translate-y-0.5',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
